<template>
    <ul class="af-dashboard-menu afu-flex afu-flex-col afu-m-0 afu-p-0 afu-list-none afu-w-64 afu-rounded-card afu-shadow-lg afu-px-5 afu-py-0 afu-bg-white">
        <li
            v-for="(nav, index) in navs"
            :key="nav.label"
            class="af-dashboard-nav-item afu-border-b afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-solid afu-border-neutral-light last:afu-border-b-0"
            :class="[{ 'is-active': nav.route_name === $route.name}, `af-sidebar-${nav.route_name}`]"
        >
            <RouterLink
                v-if="!nav.hidden"
                :to="{ name: nav.route_name }"
                class="af-dashboard-nav-link afu-text-6xl afu-font-semibold afu-block afu-text-secondary hover:afu-text-secondary afu-px-o afu-py-5 afu-no-underline hover:afu-no-underline"
            >
                <span class="afu-mr-3 afu-w-4 afu-inline-block">
                    <FontAwesomeIcon
                        :icon="nav.icon"
                        class="afu-text-primary"
                    />
                </span>
                <span
                    class="afu-duration-200 afu-transition-colors hover:afu-text-primary focus:afu-text-primary"
                    :class="{ 'afu-text-primary': nav.route_name === $route.name || (index === 0 && $route.name === 'index')}"
                >
                    {{ nav.label }}
                </span>
            </RouterLink>
        </li>

        <!-- <li class="af-dashboard-nav-item afu-border-b afu-border-t-0 afu-border-r-0 afu-border-l-0 afu-border-solid afu-border-gray-300 last:afu-border-b-0">
            <a
                href="#"
                class="af-dashboard-nav-link afu-text-6xl afu-block afu-text-secondary afu-font-semibold hover:afu-text-secondary afu-px-o afu-py-5 afu-no-underline hover:afu-no-underline"
                @click.stop.prevent="logout"
            >
                <span class="afu-mr-3">
                    <FontAwesomeIcon 
                        :icon="['far', 'sign-out']" 
                        class="afu-text-primary"
                    />
                </span>
                {{ $t('dashboard_menu.logout') }}
            </a>
        </li> -->
    </ul>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Cookie from '@/services/cookie';

    export default {
        name: 'Menu',

        data() {
            return {
                navs: [],
            };
        },

        created() {
            this.navs = [
                {
                    label: this.$t('dashboard_menu.applications'),
                    route_name: 'applications',
                    route_url: '/user-dashboard/applications/',
                    icon: ['far', 'check-circle'],
                    hidden: this.$_seekerTabByCode('applications').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.saved_jobs'),
                    route_name: 'saved-jobs',
                    route_url: '/user-dashboard/saved-jobs/',
                    icon: ['far', 'heart'],
                    hidden: this.$_seekerTabByCode('saved_jobs').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.job_alerts'),
                    route_name: 'job-alerts',
                    route_url: '/user-dashboard/job-alerts/',
                    icon: ['far', 'bell'],
                    hidden: this.$_seekerTabByCode('job_alerts').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.profile_details'),
                    route_name: 'profile',
                    route_url: '/user-dashboard/profile/',
                    icon: ['far', 'user-circle'],
                    hidden: this.$_seekerTabByCode('profile').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.work_preferences'),
                    route_name: 'work-preferences',
                    route_url: '/user-dashboard/work-preferences/',
                    icon: ['far', 'briefcase'],
                    hidden: this.$_seekerTabByCode('work_pref').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.documents'),
                    route_name: 'documents',
                    route_url: '/user-dashboard/documents/',
                    icon: ['far', 'file-alt'],
                    hidden: this.$_seekerTabByCode('documents').is_hidden,
                },
                {
                    label: this.$t('dashboard_menu.account_settings'),
                    route_name: 'settings',
                    route_url: '/user-dashboard/settings/',
                    icon: ['far', 'cog'],
                    hidden: this.$_seekerTabByCode('account_settings').is_hidden,
                },
            ];

            if (this.$route.name === 'index') {
                const visibleMenu = this.navs.find(ele => !ele.hidden);
                if (visibleMenu) {
                    this.$router.push({ name: visibleMenu.route_name });
                }
            }
        },

        computed: {
            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
                $_seekerTabByCode: 'seekerTabByCode',
            }),
        },

        methods: {
            logout() {
                Cookie.deleteToken();
                window.location.href = '/';
            },
        },
    };
</script>
